import React from 'react';
import { Table, Row, Updater } from '@tanstack/react-table';
import { QueryKey } from '@tanstack/react-query';

type TableContextType = {
  setLastSelectedRowId: (id: string | null) => void;
  table: Table<any>;
  getRowId: (row: Row<any>) => string;
  showSelectionColumn: boolean;
  columnOrder: string[];
  setColumnOrder: (updater: Updater<string[]>) => void;
  tableId: string;
  defaultPinnedColumn: string;
  queryKey: QueryKey;
  /** Allow reordering columns by dragging their headers */
  canReorderColumns: boolean;
};

export const TableContext = React.createContext<TableContextType | undefined>(
  undefined
);

export const useTableContext = () => {
  const context = React.useContext(TableContext);
  if (context === undefined) {
    throw new Error(
      'useTableContext must be used within a TableContext.Provider'
    );
  }
  return context;
};
